import { useEnrollment } from '@actions';
import { ReactComponent as BackSignIcon } from '@assets/icons/back-sign.svg';
import Button from '@components/V4/Button';
import Modal from '@components/V4/Modal/Modal';
import SurveyAccordion from './SurveyAccordion';

interface SurveyDetailsPageProps {
  enrollmentId: string;
  isBackButtonActive?: boolean;
  onGoBack?: () => void;
}

const SurveyDetailsPage = (props: SurveyDetailsPageProps) => {
  const { enrollmentId, isBackButtonActive = false, onGoBack } = props;
  const { data: enrollment } = useEnrollment(enrollmentId);

  return (
    <>
      <Modal.Header className="relative font-raleway text-xl font-bold text-center mb-6">
        {isBackButtonActive && (
          <Button
            icon={<BackSignIcon />}
            className="absolute top-0 left-6"
            variant="secondary"
            onClick={onGoBack}
            buttonText="Back"
          />
        )}

        {enrollment && <h3>Survey for {enrollment.course.title}</h3>}
      </Modal.Header>
      <Modal.Body>
        {enrollment && <SurveyAccordion enrollment={enrollment} defaultIsAccordionOpen={false} />}
      </Modal.Body>
    </>
  );
};

export default SurveyDetailsPage;
